import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { SearchableSelect } from '../_shared/forms/FormMultiSelect';
import DatePicker from 'react-datepicker/es';
import moment from 'moment';
import JobService from '../../services/JobService';
import FormError from '../_shared/forms/FormError';
import SubmitButton from '../_shared/SubmitButton';

export default class ReallocateJob extends Component {
    constructor(props) {
        super(props);

        this.state = {
            provider: this.props.provider,
            execution_date: this.props.execution_date ? new Date(this.props.execution_date) : '',
            errors: {},
            loading: false,
        };

        this.jobService = new JobService();
    }

    handleSearchableSelectChange = (e) => {
        this.setState({
            provider: e,
        });
    };

    handleDateChange = (date) => {
        let errorsObject = { ...this.state.errors };
        delete errorsObject[name];

        if (moment(date).isValid()) {
            this.setState({ execution_date: date, errors: errorsObject });
        } else {
            this.setState({ execution_date: '' });
        }
    };

    // isWeekday = (date) => {
    //     const day = new Date(date).getDay();
    //     return day !== 0 && day !== 6;
    // };

    validateForm = () => {
        let errors = {};

        if (!this.state.execution_date) {
            errors['execution_date'] = 'Planned date is required';
        }

        if (!this.state.provider) {
            errors['provider'] = 'Provider is required';
        }

        this.setState({ errors: errors });

        if (Object.keys(errors).length > 0) {
            toastr.error('Please fill in all required fields');
        }

        return Object.keys(errors).length === 0;
    };

    onSubmit = (e) => {
        e.preventDefault();

        if (this.validateForm()) {
            this.setState({ loading: true });

            let formData = new FormData();

            formData.append('_method', 'PATCH');
            formData.append('execution_date', moment(this.state.execution_date).format('YYYY/MM/DD'));
            formData.append('provider', this.state.provider.value);

            this.jobService
                .reallocateJob(this.props.job_id, formData)
                .then((res) => {
                    this.setState({ loading: false });
                    window.location.reload();
                })
                .catch(() => {
                    this.setState({ loading: false });
                    window.location.reload();
                });
        }
    };

    render() {
        return (
            <form onSubmit={this.onSubmit}>
                <div className="row align-items-center">
                    <div className="col-md-4">
                        <div className="form-group">
                            <SearchableSelect
                                name="provider"
                                options={this.props.providers}
                                value={this.state.provider}
                                handleChange={this.handleSearchableSelectChange}
                                label="Select provider"
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Select planned date</label>
                            <DatePicker
                                name="execution_date"
                                className="form-control"
                                placeholderText="Planned date..."
                                minDate={new Date()}
                                onChange={(date) => this.handleDateChange(date)}
                                selected={this.state.execution_date}
                                dateFormat="dd/MM/yyyy"
                                isClearable
                            />
                            <FormError error={this.state.errors.execution_date || ''} class={'d-block'} />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <SubmitButton
                            buttonText="Reallocate manually"
                            loading={this.state.loading}
                            style={{ width: 200 }}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

if (document.getElementById('reallocate-job')) {
    let element = document.getElementById('reallocate-job');
    let provider = element.dataset.provider;
    ReactDOM.render(
        <ReallocateJob
            providers={JSON.parse(element.dataset.providers)}
            provider={provider ? JSON.parse(provider) : []}
            execution_date={element.dataset.execution_date}
            job_id={element.dataset.job_id}
        />,
        element
    );
}
